import "./style.scss"

export default function EmptySearch() {
  return (
    <div className="compare-search-empty">
      Search for resources (portfolios, securities, baskets...)
    </div>
  )
}
